// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2FQa_","alert":"SettungsInbox_alert__1AvdA"};